<template>
  <div class="comment-pop">
    <div class="user_active">
      <div class="input">
        <img src="@/assets/images/common/edit-icon.png" alt="">
        <van-field placeholder="说点什么..." readonly @click="handleInput" />
      </div>
      <div class="info">
        <div class="info_item">
          <img class="img" src="../../../assets/student/see.png" alt="" />
          <span class="num">{{ details.visitNum > 0 ? details.visitNum : 0 }}</span>
        </div>
        <div class="info_item" @click="handleGo('comment')">
          <img class="img" src="../../../assets/student/info.png" alt="" />
          <span class="num">{{ details.commentNum > 0 ? details.commentNum : 0 }}</span>
        </div>
        <div class="info_item" @click="handleLike">
          <img class="img" v-if="details.isLike > 0" src="@/assets/images/zone/img20.png" alt="" />
          <img class="img" v-else src="@/assets/images/zone/img17.png" alt="" />
          <span class="num"> {{ details.likeNum > 0 ? details.likeNum : 0 }} </span>
        </div>
      </div>
    </div>
    <commentDialogVue @handleEmit="handleEmit" :files="files" :detailData="details" v-show="show"></commentDialogVue>
    <!-- <comment :postId="postId" v-if="showComment" ref="comment"></comment> -->
  </div>
</template>
<script>
import { postLike, delLike } from '@/api/zone'
import comment from '../comment.vue'
import commentDialogVue from './commentDialog.vue'
// import { rolesClick } from '../data'
export default {
  props: {
    detailData: {},
    files: [],
    isComment: false,
    roles: {}
  },
  components: {
    comment,
    commentDialogVue
  },
  data () {
    return {
      details: {},
      show: false,
      isLoad: false,
      postId: '',
      showComment: false,
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    detailData (newval) {
      this.details = newval
      this.showComment = this.isComment
    }
  },
  mounted () {
    this.postId = this.$route.query.postId
    // if (this.$route.path === '/comment') {
    //   let postId = this.$route.query.postId
    //   postDetails({postbarId: postId}).then(res => {
    //     this.details = res.data
    //   })
    // }
  },
  methods: {
    handleEmit() {
      if (this.$parent.handleGetlist) {
        this.$parent.handleGetlist()
      } else if (this.$parent.$refs.comment.handleGetlist) {
        this.$parent.$refs.comment.handleGetlist()
      }
    },
    handleInput () {
      this.show = true
    },
    handleGo (type) {
      switch (type) {
        case 'comment':
          this.showComment = true
          // if (this.$route.path === '/comment') return
          // this.$router.push({
          //   path: `/comment?postId=${this.$route.query.postId}`
          // })

          break

        default:
          break
      }
    },
    handleLike () {
      // if (rolesClick(this.roles, this.userInfo)) return
      if (`${this.details.isLike}` > 0) {
        delLike({ id: this.details.isLike }).then(() => {
          this.details.likeNum--
          this.$toast('取消点赞成功')
          this.details.isLike = '0'
        })
        return
      }
      let params = {
        likeId: this.details.id,
        likeTitle: this.details.subjectName,
        userId: this.userInfo.id,
        targetUserId: this.details.iepUserDTO.id,
        targetUserName: this.details.iepUserDTO.realName,
        targetHeadPic: this.details.iepUserDTO.headPicUrl,
        kind: this.details.kind
      }
      if (this.files && this.files.length > 0) {
        params.cover = this.files[0].url
      }
      if (this.details.liveDTO && Object.keys(this.details.liveDTO).length > 0) {
        params.cover = this.details.liveDTO.liveCover
      }
      if (this.details.coverInfo && this.details.coverInfo.url) {
        params.cover = this.details.coverInfo.url
      }
      postLike(params).then(res => {
        this.details.likeNum++
        this.details.isLike = res.data
        this.$toast('点赞成功')
      })
    },
  }
}
</script>
<style lang="less" scoped>
.comment-pop {
  .user_active {
    width: 375px;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 6px 14px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 -5px 10px -5px #eee;
    background-color: #fff;
    z-index: 99;

    .input {
      display: flex;
      align-items: center;
      margin-right: 14px;
      width: 142px;
      height: 32px;
      background: #f5f5f5;
      border-radius: 16px;
      padding-left: 10px;

      img {
        width: 14px;
        margin-right: 5px;
      }

      .van-cell {
        background: #f5f5f5;
        border-radius: 16px;
        line-height: 32px;
        padding: 0;
        box-sizing: border-box;
      }

      .van-field__body {
        width: 142px;
        height: 32px;
        background: #f5f5f5;
        border-radius: 16px 16px 16px 16px;
        line-height: 32px;
      }

      /deep/ .van-field__control::-webkit-input-placeholder {
        /* placeholder颜色 */
        color: #7a8494 !important;
        /* placeholder字体大小 */
        font-size: 12px !important;
      }
    }

    .info {
      width: 200px;
      display: flex;
      justify-content: space-between;

      &_item {
        display: flex;
        align-items: center;

        .img {
          width: 16px;
          height: 14px;
          margin-right: 4px;
        }

        .num {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          font-size: 12px;
          color: #7a8494;
          line-height: 38px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/commentPop.vue